module.exports = __webpack_public_path__ + "61979758.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/right-arrow-angle.svg
// module id = 2007
// module chunks = 1 17 19